import api from '../../../api/api'

export default {
    loadProducts: async (context, products) => {    
        context.commit('LOADING')    
        let data  =  await api.getProducts(products)
        context.commit('SET_PRODUCTS', data)
        context.commit('LOADED')
    },
    loadKit: async (context, kit) => {    
        context.commit('LOADING')    
        let data  =  await await api.getProducts([kit])
        context.commit('SET_KIT', data)
        context.commit('LOADED')
    }
}